import React, { Dispatch, SetStateAction } from "react";
import { Badge } from "@merge-api/merge-javascript-shared";
import { SectionHeaderWrapper } from "../../../shared/SectionHeaderWrapper";
import ConfigurationSelectiveSyncCard from "./ConfigurationSelectiveSyncCard";
import ConfigurationSelectiveSyncSettingsPage from "./ConfigurationSelectiveSyncSettingsPage";
import { OrganizationCustomization } from "../link/context/CustomizationContext";
import useAppContext from "../../../context/useAppContext";
import { UserType } from "../../../../models/Entities";

type ConditionPresetHeaderProps = {
  previewLinkEnabled: boolean;
  setConditionPresetPreviewLinkDialogOpen: Dispatch<SetStateAction<boolean>>;
  organizationCustomization: OrganizationCustomization | null;
  setOrganizationCustomization: (organizationCustomization: OrganizationCustomization) => void;
  showGatedSelectiveSync: boolean;
};

const ConditionPresetHeader = ({
  previewLinkEnabled,
  setConditionPresetPreviewLinkDialogOpen,
  organizationCustomization,
  setOrganizationCustomization,
  showGatedSelectiveSync,
}: ConditionPresetHeaderProps) => {
  const { user } = useAppContext();
  const isSupportRole = user.type === UserType.support;

  return (
    <SectionHeaderWrapper
      title={
        <div className="flex flex-row gap-3 items-center">
          Selective Sync
          <Badge color="blue">Beta</Badge>
        </div>
      }
      subtitle="Create preset filters that automatically apply to new Linked Accounts. Integration support is limited."
      docsUrl="https://help.merge.dev/en/articles/9113654-selective-sync"
    >
      {/* toolbar */}
      {showGatedSelectiveSync ? (
        <ConfigurationSelectiveSyncSettingsPage
          setConditionPresetPreviewLinkDialogOpen={setConditionPresetPreviewLinkDialogOpen}
        />
      ) : (
        <ConfigurationSelectiveSyncCard
          previewLinkEnabled={previewLinkEnabled}
          setConditionPresetPreviewLinkDialogOpen={setConditionPresetPreviewLinkDialogOpen}
          organizationCustomization={organizationCustomization}
          setOrganizationCustomization={setOrganizationCustomization}
        />
      )}
    </SectionHeaderWrapper>
  );
};

export default ConditionPresetHeader;
